import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../async-state';
import { type IDeliveryRecord, type IDeliveryState } from './types';

export const preloadedState: IDeliveryState = {
  inProcess: false,
  deliveries: undefined,
};

const deliverySlice = createSlice({
  name: 'Delivery',
  initialState: preloadedState,
  reducers: {
    deliveryLoadByCountry: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(countryTypeIsoCode: string) {
        return { payload: { countryTypeIsoCode } };
      },
    },
    deliveryLoadByCountryResponse: {
      reducer(state, action: { payload: { deliveries: IDeliveryRecord[] } }) {
        state.inProcess = false;
        state.deliveries = action.payload.deliveries;
      },
      prepare(deliveries: IDeliveryRecord[]) {
        return { payload: { deliveries } };
      },
    },
    deliveryCreate: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(
        countryTypeIsoCode: string,
        currencyTypeIsoCode: string,
        weight: number,
        price: number,
      ) {
        return {
          payload: { countryTypeIsoCode, currencyTypeIsoCode, weight, price },
        };
      },
    },
    deliveryUpdate: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(
        id: number,
        countryTypeIsoCode: string,
        currencyTypeIsoCode: string,
        weight: number,
        price: number,
      ) {
        return {
          payload: {
            id,
            countryTypeIsoCode,
            currencyTypeIsoCode,
            weight,
            price,
          },
        };
      },
    },
    deliveryDelete: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(id: number, countryTypeIsoCode: string) {
        return { payload: { id, countryTypeIsoCode } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Delivery'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  deliveryLoadByCountry,
  deliveryLoadByCountryResponse,
  deliveryCreate,
  deliveryUpdate,
  deliveryDelete,
} = deliverySlice.actions;
export default deliverySlice.reducer;
